

















import Vue from 'vue'

import BaseSelectWrap from '../Base/SelectWrap.vue'

import types from '../../store/types'

export default Vue.extend({
  components: {
    BaseSelectWrap
  },

  computed: {
    selected: {
      get(): string {
        return this.$store.state.Current.shape
      },
      set(newValue: string): void {
        this.$store.commit(types.mutations.CURRENT_SHAPE, newValue)
      }
    },
    optgroups(): any[] {
      return this.$store.state.Shape.group
    }
  },

  methods: {
    changeShape(e: Event) {
      const target = e.target as HTMLSelectElement
      this.selected = target.value

      this.$store.commit(types.mutations.NAVIGATION_ACTIVE, 0)
    }
  }
})
